module.exports = __webpack_public_path__ + "static/media/white-shirt-formal.813e2def.jpg";